import { DatabaseRecord } from "@/core/repos/table.repo";

interface FeeLadderModelExt {
    provinceName?: string,
}

export interface FeeLadderModel extends DatabaseRecord, FeeLadderModelExt {
    name: string;
    status: string;
    enviromentFee: number;
    vat: number;
    code: number;
    provinceId: string;
    waterFactoryId: string;
    floorIndex: number;
    otherPrice: number;
    maxIndex: number;
    ladderType: string;
    discountRate: number;
    invoiceDateType: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
}

export class FeeLadderModelFactory {
    static getEmpty(): FeeLadderModel {
        return {
            id: "",
            name: "",
            status: "",
            enviromentFee: 0,
            vat: 0,
            code: 0,
            provinceId: "",
            waterFactoryId: "",
            floorIndex: 0,
            otherPrice: 0,
            maxIndex: 0,
            ladderType: "",
            discountRate: 0,
            invoiceDateType: "",
            createdAt: new Date(),
            updatedAt: new Date(),
            createdBy: "",
            updatedBy: ""
        };
    }
}
